import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { cloneVNode } from 'vue';
import BaseInputComponent from './BaseInputComponent.vue';
import safeFile from '@/slango-multiverse/helpers/safeFile';
import utils from '@/slango-multiverse/helpers/utils';
import { globalProperties } from '@/main.js';
export default {
  extends: BaseInputComponent,
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    accept: {},
    hintText: {
      type: String,
      default: 'Selecciona tu archivo'
    },
    maxSize: {
      type: Number,
      default: 100000000
    },
    checkMaxSize: {
      type: Boolean,
      default: true
    },
    directory: Boolean,
    directories: Boolean,
    embedded: {
      type: Boolean,
      default: () => globalProperties.$state.embedded
    },
    showFiles: {
      type: Boolean,
      default: true
    },
    globalDragAndDrop: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],
  computed: {
    node() {
      const n = this.$slots.default?.()[0];
      return n ? cloneVNode(n, {
        onClick: e => this.EventManager(e),
        onDrop: e => {
          e.preventDefault();
          this.OnDrop(e);
        },
        onDragover: e => {
          e.preventDefault();
          this.OnDragOver(e);
        }
      }) : null;
    },
    normalizedAccept() {
      const accept = this.accept ?? [];
      return Array.isArray(accept) ? accept : accept.split(',');
    },
    selectedFiles() {
      return this.embedded ? this.value?.map(v => {
        return {
          name: v
        };
      }) : this.value;
    },
    fileExtensionIcons: function () {
      const icons = this.normalizedAccept.map(extension => {
        if (extension === '.xlsx' || extension === '.csv') {
          return require('@/assets/icons/drag-excel.svg');
        } else if (extension === '.pdf') {
          return require('@/assets/icons/drag-pdf.svg');
        } else if (extension === '.docx') {
          return require('@/assets/icons/drag-docx.svg');
        } else if (extension === '.png' || extension === '.jpg') {
          return require('@/assets/icons/drag-img.svg');
        } else if (extension === '.pptx') {
          return require('@/assets/icons/drag-pptx.svg');
        } else if (extension === '.txt') {
          return require('@/assets/icons/drag-file.svg');
        }
      });
      return [...new Set(icons)];
    },
    containsSlot() {
      return !!this.$slots.default;
    }
  },
  data: function () {
    return {
      utils,
      dragOver: undefined,
      globalDragging: false,
      timeout: null,
      dragCounter: 0
    };
  },
  created() {
    this.$emit('actionCallback', this.EventManager);
  },
  mounted() {
    if (this.globalDragAndDrop) {
      window.addEventListener('dragenter', this.OnGlobalDragEnter);
      window.addEventListener('dragleave', this.OnGlobalDragLeave);
      window.addEventListener('drop', this.OnGlobalDrop);
      window.addEventListener('dragover', this.OnGlobalDragOver);
    }
  },
  beforeUnmount() {
    if (this.globalDragAndDrop) {
      window.removeEventListener('dragenter', this.OnGlobalDragEnter);
      window.removeEventListener('dragleave', this.OnGlobalDragLeave);
      window.removeEventListener('drop', this.OnGlobalDrop);
      window.removeEventListener('dragover', this.OnGlobalDragOver);
    }
  },
  methods: {
    EventManager: function () {
      if (this.embedded) {
        this.$desktopAppComunication("OpenNativeSelectionDialog", {
          accept: "",
          multiple: this.multiple,
          directory: this.directory
        }).then(r => this.OnFilesSelect(r?.filter(f => this.normalizedAccept.includes('.' + f.split('.').reverse()[0])), false));
      } else {
        this.$refs['input-element-ref'].click();
      }
    },
    OnDragOver: function () {
      clearTimeout(this.timeout);
      this.dragOver = true;
      this.timeout = setTimeout(() => {
        this.dragOver = false;
      }, 100);
    },
    OnDrop: function (event) {
      if (this.embedded) return;
      this.globalDragging = false;
      this.dragCounter = 0;
      this.OnFilesSelect(event.dataTransfer.files);
    },
    /** 🔹 Manejadores globales */
    OnGlobalDragEnter: function (event) {
      event.preventDefault();
      this.dragCounter++;
      this.globalDragging = true;
    },
    OnGlobalDragOver: function (event) {
      event.preventDefault();
    },
    OnGlobalDragLeave: function (event) {
      event.preventDefault();
      if (this.dragCounter > 2) {
        this.dragCounter = 1;
      }
      this.dragCounter--;
      if (this.dragCounter <= 0) {
        this.globalDragging = false;
        this.dragCounter = 0;
      }
    },
    OnGlobalDrop: async function (event) {
      event.preventDefault();
      if (this.embedded) return;
      this.globalDragging = false;
      this.dragCounter = 0;
      const entries = Array.from(event.dataTransfer.items).map(item => item.webkitGetAsEntry?.()).filter(Boolean);
      const allFiles = [];
      for (const entry of entries) {
        const files = await this.TraverseEntry(entry);
        allFiles.push(...files);
      }
      this.OnFilesSelect(allFiles);
    },
    //recorre directorios y subdirectorios y sube los documentos en su interior (solo se usa en drag and drop global)
    TraverseEntry: async function (entry, path = '') {
      if (entry.isFile) {
        const file = await new Promise((resolve, reject) => {
          entry.file(resolve, reject);
        });
        file.fullPath = path + file.name;
        return [file];
      }
      if (entry.isDirectory) {
        const reader = entry.createReader();
        const allFiles = [];
        const readAllEntries = async () => {
          const entries = await new Promise((resolve, reject) => {
            reader.readEntries(resolve, reject);
          });
          if (entries.length === 0) return;
          for (const e of entries) {
            const files = await this.TraverseEntry(e, `${path}${entry.name}/`);
            allFiles.push(...files);
          }
          await readAllEntries(); // seguir leyendo hasta vaciar el directorio
        };
        await readAllEntries();
        return allFiles;
      }
      return [];
    },
    FilterFilesByExtension: async function (filelist) {
      const files = await safeFile.secureFiles([...filelist]);
      if (!this.normalizedAccept.length) {
        return files;
      }
      return files.filter(f => this.normalizedAccept.includes('.' + f?.name.split('.').reverse()[0].toLowerCase()));
    },
    OnFilesSelect: async function (files_, filter = true) {
      if (!files_?.length) return;
      files_ = Array.from(files_);
      if (!this.embedded && this.checkMaxSize) {
        const size = files_.reduce((acc, current) => acc + current.size, 0);
        if (size > this.maxSize) {
          this.$createToastMessage({
            key: 'size-limit',
            fixed: true,
            type: 'error',
            text: this.$st('scriptlaunch.error.filesizeexceeded', {
              humanActualSize: this.$formatBytes(size),
              humanLimitSize: this.$formatBytes(this.maxSize)
            }),
            close: false,
            alive: 3000
          });
          return;
        }
      }
      const files = filter ? await this.FilterFilesByExtension(files_) : files_;
      if (!files?.length) {
        this.$createToastMessage({
          key: 'files-no-supported',
          fixed: true,
          type: 'error',
          text: 'No se ha encontrado ningún archivo con el formato esperado',
          close: false,
          alive: 5000
        });
        return;
      }
      if (files?.length < files_.length) {
        this.$createToastMessage({
          key: 'some-files-no-supported',
          fixed: true,
          type: 'error',
          text: 'Algunos archivos no tienen el formato esperado',
          close: false,
          alive: 5000
        });
      }
      this.$emit('input', files);
      if (this.showFiles) {
        this.value = this.multiple ? [...this.value, ...files] : [files[0]];
      }
    },
    RemoveFile: function (index) {
      this.value.splice(index, 1);
    },
    OpenDialogFolderSelector: async function () {
      if (this.$embedded) {
        this.$desktopAppComunication("OpenNativeSelectionDialog", {
          accept: "",
          multiple: this.multiple,
          directory: this.directory
        }).then(r => this.OnFilesSelect(r, false));
      }
    }
  }
};